import { EMemberStatus } from '@/config/member';

import { TMemberAction, MemberAction } from './MemberAction';

type TMemberMenuProps = {
  status: EMemberStatus;
  execute: (action: TMemberAction) => void;
  permissionLevel: boolean;
};

export const MemberMenu = ({ status, execute, permissionLevel }: TMemberMenuProps) => {
  switch (status) {
    case EMemberStatus.INVITED:
      return (
        <>
          <MemberAction action="cancel" execute={execute} />
          {permissionLevel && <MemberAction action="transferOwnership" execute={execute} />}
          <MemberAction action="remove" execute={execute} />
        </>
      );

    case EMemberStatus.ACTIVE:
      return (
        <>
          <MemberAction action="edit" execute={execute} />
          <MemberAction action="suspend" execute={execute} />
          {permissionLevel && <MemberAction action="transferOwnership" execute={execute} />}
          <MemberAction action="remove" execute={execute} />
        </>
      );

    case EMemberStatus.SUSPENDED:
      return (
        <>
          <MemberAction action="edit" execute={execute} />
          <MemberAction action="reactivate" execute={execute} />
          {permissionLevel && <MemberAction action="transferOwnership" execute={execute} />}
          <MemberAction action="remove" execute={execute} />
        </>
      );
  }
};
